module.exports = __webpack_public_path__ + "img/neo-bg-white.ad1a4f29.svg";